const AnimationSection = () => {
  return (
    <section className="py-24 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 text-center mb-16">
        <span className="inline-block px-3 py-1 rounded-full border border-[#1F1F1F] text-xs font-typewriter uppercase mb-4">Video Content</span>
        <h2 className="font-serif-display text-5xl lg:text-7xl mb-6">Анимируйте за <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#b7eb6f] to-[#b7eb6f]">60 секунд</span></h2>
        <p className="font-sans text-lg opacity-80 max-w-2xl mx-auto">
          Создавайте анимацию карточки для любых каналов. Добавьте движение — увеличьте внимание.
        </p>
      </div>

      <div className="w-full overflow-hidden bg-[#1F1F1F] py-12" style={{ transform: 'rotate(-2deg) scale(1.1)' }}>
        <div className="flex gap-8 justify-center min-w-max">
          <div className="w-64 h-40 bg-white/10 rounded border-y-8 border-dashed border-white/20 flex items-center justify-center">
            <i className="ph-fill ph-play-circle text-4xl text-white/50"></i>
          </div>
          <div className="w-64 h-40 bg-white/10 rounded border-y-8 border-dashed border-white/20 flex items-center justify-center">
            <i className="ph-fill ph-video-camera text-4xl text-white/50"></i>
          </div>
          <div className="w-64 h-40 bg-white/10 rounded border-y-8 border-dashed border-white/20 flex items-center justify-center">
            <i className="ph-fill ph-film-strip text-4xl text-white/50"></i>
          </div>
          <div className="w-64 h-40 bg-white/10 rounded border-y-8 border-dashed border-white/20 flex items-center justify-center">
            <i className="ph-fill ph-youtube-logo text-4xl text-white/50"></i>
          </div>
          <div className="w-64 h-40 bg-white/10 rounded border-y-8 border-dashed border-white/20 flex items-center justify-center">
            <i className="ph-fill ph-tiktok-logo text-4xl text-white/50"></i>
          </div>
          <div className="w-64 h-40 bg-white/10 rounded border-y-8 border-dashed border-white/20 flex items-center justify-center">
            <i className="ph-fill ph-instagram-logo text-4xl text-white/50"></i>
          </div>
        </div>
      </div>

      <div className="text-center mt-12">
        <a href="https://trippika.ru/seller-login" className="bg-[#1F1F1F] text-white px-8 py-3 rounded-full font-typewriter uppercase text-xs tracking-widest hover:scale-105 transition-transform inline-block">
          Создать анимацию
        </a>
      </div>
    </section>
  );
};

export default AnimationSection;
